/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new AttributeAPI();
